import { Researcher } from "./researcher";
import { Model } from "./model";

export class ResearcherCertificate extends Model {

  creationDate?: Date;

  endDate?: Date;

  revokeDate?: Date;

  researcher?: Researcher;

  cmId?: string;

}
